import Preview from '../../views/Preview'

Preview.install = function (Vue) {
    Vue.component(Preview.name, Preview)
}

export default Preview
